<template>
    <!-- Rendered on <body>: inside the sidebar the dialog ends up underneath the page backdrop
         (its stacking context traps it) and can't be clicked. -->
    <teleport to="body">
        <punch-in-out-modal v-if="active" :key="mode" v-model="active" :punch="mode === 'out'"/>
    </teleport>
</template>

<script>
import PunchInOutModal from "./PunchInOutModal";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";

export default {
    name: "GlobalPunchIn",
    components: {PunchInOutModal},
    data() {
        return {
            active: false,
            checking: false,
            mode: 'in',
        }
    },
    created() {
        // Opened from anywhere (e.g. the punch alert) via a window event, so employees can
        // punch in/out without navigating to the dashboard.
        this.openInHandler = () => this.open('in');
        this.openOutHandler = () => this.open('out');
        window.addEventListener('open-punch-in', this.openInHandler);
        window.addEventListener('open-punch-out', this.openOutHandler);
    },
    beforeUnmount() {
        window.removeEventListener('open-punch-in', this.openInHandler);
        window.removeEventListener('open-punch-out', this.openOutHandler);
    },
    methods: {
        /**
         * Ask the server what the real state is before opening anything, so a stale alert can
         * never offer "Punch in" to someone who is already tracking time (or the reverse).
         */
        open(requested) {
            if (this.active || this.checking) {
                return;
            }
            this.checking = true;

            axiosGet(`${TENANT_BASE_URL}employees/check-punch-in`).then(({data}) => {
                const punchedIn = !!data.punched;

                if (requested === 'in' && punchedIn) {
                    this.$toastr.s('', this.$t('you_are_already_punch_in'));
                } else if (requested === 'out' && !punchedIn) {
                    this.$toastr.e('', this.$t('you_dont_punch_in_yet'));
                } else {
                    this.mode = requested;
                    this.active = true;
                    return;
                }

                // The screen was out of date: bring the timer/buttons back in sync.
                this.$hub.$emit('reload-punch-in-out-button');
                this.$hub.$emit('reload-dashboard');
            }).catch(() => {
                // If the state can't be checked, fall back to what the caller asked for.
                this.mode = requested;
                this.active = true;
            }).finally(() => {
                this.checking = false;
            });
        }
    }
}
</script>
